import axios from 'axios'

import CONFIGURATION from '../../constants/endpoints'
import { getError, getHeaders } from '../helpers'

const scheduleEnpoint = CONFIGURATION.endpoints.schedules

/**
 * Get schedule
 * @see https://d.dev.nixi1.dkv.es/api-docs/#/Schedule/get_dashboard_schedules
 *
 * @param {object} data
 * @param {[string]} data.tag
 * @param {[string]} data.createdTo
 * @param {[string]} [data.group]
 *
 * @returns {Promise<object>}
 */
async function get(data) {
  const { tag, group, createdTo } = data

  try {
    if (!Array.isArray(tag) || !tag.length) throw new Error('tag is required.')
    if (!Array.isArray(createdTo) || !createdTo.length) throw new Error('createdTo is required.')

    const { data } = await axios({
      url: scheduleEnpoint,
      method: 'get',
      headers: getHeaders(true),
      params: { tag, group, createdTo }
    })

    return data.result
  } catch(error) {
    throw getError(error)
  }
}

/**
 * Create or update schedules
 * @see https://d.dev.nixi1.dkv.es/api-docs/#/Schedule/post_dashboard_schedules
 *
 * @param {object} data
 * @param {'overlap'} [data.validate]
 * @param {[{
 *  _id?: string,
 *  name?: string,
 *  company: string,
 *  tag: string,
 *  group: string,
 *  schedule: object
 * }]} data.schedules
 *
 * @returns {Promise<object>}
 */
async function post(data) {
  const { validate, schedules } = data

  try {
    if (!Array.isArray(schedules) || !schedules.length) throw new Error('schedules is required.')

    const { data } = await axios({
      url: scheduleEnpoint,
      method: 'post',
      headers: getHeaders(true),
      data: { validate, schedules }
    })

    return data.result
  } catch(error) {
    throw getError(error)
  }
}

export default {
  get, post
}
